import {ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit} from '@angular/core';
import {filter, tap} from 'rxjs/operators';
import {merge} from 'rxjs';
import {AsaxBookmarkingService} from 'asax-bookmarking';
import {AsaxHeaderService, HeaderFilter} from 'asax-common';
import {DropdownSearchInput, TextSearchInput, TypeaheadSearchInput} from "../search-input.model";

@Component({
  selector: 'asax-header-search-input-container',
  templateUrl: './search-input-container.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SearchInputContainerComponent implements OnInit {
  @Input() searchInput: TextSearchInput | DropdownSearchInput | TypeaheadSearchInput;

  constructor(private readonly asaxBookmarkingService: AsaxBookmarkingService,
              private readonly asaxHeaderService: AsaxHeaderService,
              private readonly changeDetectorRef: ChangeDetectorRef) {
  }

  ngOnInit(): void {
    merge(
      this.asaxBookmarkingService.getQueryParam(this.searchInput?.id),
      this.asaxBookmarkingService.getQueryParam(this.searchInput?.legacyId)
    ).pipe(
      filter(value => value?.length > 0),
      filter(value => value !== this.searchInput.value),
      tap(value => (this.searchInput = {...this.searchInput, value})),
      tap(() => this.changeDetectorRef.markForCheck())
    ).subscribe();

    merge(
      this.asaxHeaderService.headerFiltersRemoved(),
      this.asaxHeaderService.headerFilterRemoved(this.searchInput?.id)
    ).pipe(
      tap(value => (this.searchInput = {...this.searchInput, value: undefined})),
      tap(() => this.changeDetectorRef.markForCheck())
    ).subscribe();

    this.asaxHeaderService.getHeaderFilterIsDisabled(this.searchInput?.id).pipe(
      filter(isDisabled => isDisabled !== this.searchInput.isDisabled),
      tap(isDisabled => (this.searchInput = {...this.searchInput, isDisabled})),
      tap(() => this.changeDetectorRef.markForCheck())
    ).subscribe();
  }

  onFilter(headerFilter: HeaderFilter): void {
    this.asaxHeaderService.upsertHeaderFilter(headerFilter);
    this.bookmarkFilter(headerFilter);
  }

  private bookmarkFilter(headerFilter: HeaderFilter) {
    const {value} = headerFilter;

    if (value?.length > 0) {
      this.asaxBookmarkingService.addParamsToUrl({[this.searchInput.id]: value});
    } else {
      this.asaxBookmarkingService.removeParamsFromUrl(this.searchInput.id);
    }
  }
}
